import React from 'react';
import { Button as ButtonNew } from './Button';
import { convertOldButtonProps } from './converter.old';
import type { OldButtonProps } from './converter.old';

export type { ButtonIconProps } from './Button';
export type ButtonProps = OldButtonProps;

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  return <ButtonNew {...convertOldButtonProps(props)} ref={ref} />;
});
